<template>
  <v-form ref="form" v-model="valid">
    <v-col cols="11">
      <label>CSV
        <input type="file" id="file" ref="file" @change="handleFileUpload()" />
      </label>
    </v-col>
    <v-col cols="11">
      <v-btn :disabled="!valid" color="success" @click="validate">Insert</v-btn>
    </v-col>
    <v-col cols="11">
      <v-btn :to="{ name: 'Dashboard' }" color="white">Dashboard</v-btn>
    </v-col>
    <div v-if="errors.length">
      <b>Erreur:</b>
      <ul>
        <li v-for="error in errors" :key="error">{{ error }}</li>
      </ul>
    </div>
    <div v-if="status.length">
      <b>Insertions</b> {{ status }}
    </div>
  </v-form>
</template>

<script>
export default {
  data () {
    return {
      valid: true,
      file: '',
      errors: [],
      status: []
    }
  },
  methods: {
    handleFileUpload () {
      this.file = this.$refs.file.files[0]
    },
    validate () {
      this.$refs.form.validate().then(valid => {
        if (!valid) return
        this.errors = []
        this.status = []
        var errs = this.errors
        var statuses = this.status
        this.$apiclient.addUsersBulk(this.file)
          .then(response => {
            if (response.status !== 200) errs.push(response.statusText)
            statuses.push('Ok')
          })
          .catch(error => {
            if (error.response.status === 401) {
              errs.push("Vous n'êtes pas connecté ou non authorisé")
            } else {
              errs.push(error.response.statusText)
            }
          })
      })
    }
  }
}
</script>
